<div class="chart-container">
  <app-line-chart [data]="data" [labels]="labels"></app-line-chart>
</div>
